import type { AdapterStatus } from './models'

export type AppErrorCode =
  | 'auth_duplicate'
  | 'auth_duplicate_username'
  | 'auth_invalid'
  | 'auth_not_found'
  | 'auth_unavailable'
  | 'ticket_duplicate'
  | 'ticket_invalid'
  | 'ticket_offline'
  | 'ticket_revoked'
  | 'ticket_unavailable'
  | 'check_in_closed'
  | 'check_in_offline'
  | 'check_in_ticket_required'
  | 'not_found'
  | 'validation_error'
  | 'storage_unavailable'

export class AppError extends Error {
  readonly code: AppErrorCode
  readonly status: AdapterStatus

  constructor(code: AppErrorCode, message: string, status: AdapterStatus = 'error') {
    super(message)
    this.name = 'AppError'
    this.code = code
    this.status = status
  }
}

export const isAppError = (value: unknown): value is AppError => value instanceof AppError

export const messageForError = (error: unknown, fallback: string): string =>
  error instanceof Error && error.message.trim() ? error.message : fallback
